(function () {
  var root = document.querySelector('[data-collection]');
  if (!root) return;

  var grid = root.querySelector('[data-collection-grid]');
  var toolbar = root.querySelector('[data-collection-toolbar]');
  if (!grid || !toolbar) return;

  var STORAGE_KEY = 'belnay.collection.cols.v3';
  var PHONE_KEY = 'belnay.collection.cols.phone';
  var phoneQuery = window.matchMedia('(max-width: 749px)');

  function closeAll(except) {
    toolbar.querySelectorAll('[data-facet-details]').forEach(function (el) {
      if (el !== except) el.removeAttribute('open');
    });
  }

  toolbar.addEventListener('toggle', function (e) {
    var details = e.target.closest('[data-facet-details]');
    if (!details || !details.open) return;
    closeAll(details);
  }, true);

  document.addEventListener('click', function (e) {
    if (!toolbar.contains(e.target)) closeAll(null);
  });

  function setGrid(cols) {
    var n = String(cols) === '5' ? '5' : '4';
    grid.setAttribute('data-cols', n);
    toolbar.querySelectorAll('[data-grid-cols]').forEach(function (btn) {
      var active = btn.getAttribute('data-grid-cols') === n;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    try { localStorage.setItem(STORAGE_KEY, n); } catch (err) {}
  }

  function setPhoneCols(cols) {
    var n = String(cols) === '1' ? '1' : '2';
    grid.setAttribute('data-cols', n);
    toolbar.querySelectorAll('[data-phone-cols]').forEach(function (btn) {
      var active = btn.getAttribute('data-phone-cols') === n;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    try { localStorage.setItem(PHONE_KEY, n); } catch (err) {}
  }

  function applyLayout() {
    if (phoneQuery.matches) {
      var phoneSaved = null;
      try { phoneSaved = localStorage.getItem(PHONE_KEY); } catch (err) {}
      setPhoneCols(phoneSaved === '1' ? '1' : '2');
      return;
    }
    var saved = null;
    try { saved = localStorage.getItem(STORAGE_KEY); } catch (err) {}
    setGrid(saved === '4' || saved === '5' ? saved : '4');
  }

  toolbar.querySelectorAll('[data-grid-cols]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      setGrid(btn.getAttribute('data-grid-cols'));
    });
  });

  toolbar.querySelectorAll('[data-phone-cols]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      setPhoneCols(btn.getAttribute('data-phone-cols'));
    });
  });

  applyLayout();
  if (phoneQuery.addEventListener) phoneQuery.addEventListener('change', applyLayout);
  else if (phoneQuery.addListener) phoneQuery.addListener(applyLayout);

  var sortSelect = toolbar.querySelector('[data-collection-sort]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      if (sortSelect.value) url.searchParams.set('sort_by', sortSelect.value);
      else url.searchParams.delete('sort_by');
      window.location.href = url.toString();
    });
  }

  toolbar.querySelectorAll('[data-facet-form]').forEach(function (form) {
    form.addEventListener('change', function (e) {
      if (!e.target || e.target.type !== 'checkbox') return;
      if (form.requestSubmit) form.requestSubmit();
      else form.submit();
    });
  });

  var drawer = root.querySelector('[data-filter-drawer]');
  var openButton = toolbar.querySelector('[data-filter-open]');
  if (!drawer || !openButton) return;

  var closeButton = drawer.querySelector('[data-filter-close]');
  var form = drawer.querySelector('[data-filter-form]');

  function parseMoney(value) {
    var text = String(value || '').replace(/\s/g, '');
    if (text.indexOf(',') !== -1 && text.indexOf('.') === -1) text = text.replace(',', '.');
    var number = parseFloat(text);
    return isNaN(number) ? null : number;
  }

  var keyboardTimer = 0;
  var pinnedTop = '';

  function keepPagePinned() {
    if (!drawer.classList.contains('is-open')) return;
    var body = document.body;
    if (!body.classList.contains('page-scroll-locked')) return;
    if (body.style.position !== 'fixed') body.style.position = 'fixed';
    if (pinnedTop && body.style.top !== pinnedTop) body.style.top = pinnedTop;
    if ((window.scrollY || 0) === 0) return;
    var html = document.documentElement;
    var prev = html.style.scrollBehavior;
    html.style.scrollBehavior = 'auto';
    window.scrollTo(0, 0);
    html.style.scrollBehavior = prev;
  }

  function holdKeyboardShield() {
    window.clearTimeout(keyboardTimer);
    drawer.classList.add('is-keyboard');
    keepPagePinned();
  }

  function releaseKeyboardShield() {
    window.clearTimeout(keyboardTimer);
    var tries = 0;
    var release = function () {
      var active = document.activeElement;
      if (active && drawer.contains(active) && active.matches && active.matches('[data-price-input]')) return;
      var vv = window.visualViewport;
      var covered = vv ? window.innerHeight - vv.height - (vv.offsetTop || 0) : 0;
      if (covered > 40 && tries < 12) {
        tries += 1;
        keyboardTimer = window.setTimeout(release, 50);
        return;
      }
      drawer.classList.remove('is-keyboard');
    };
    keyboardTimer = window.setTimeout(release, 80);
  }

  function openDrawer() {
    drawer.hidden = false;
    openButton.setAttribute('aria-expanded', 'true');
    if (window.Belnay && window.Belnay.lockPageScroll) window.Belnay.lockPageScroll('collection-filter');
    pinnedTop = document.body.style.top || '';
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', keepPagePinned);
      window.visualViewport.addEventListener('scroll', keepPagePinned);
    }
    window.requestAnimationFrame(function () {
      drawer.classList.add('is-open');
      if (closeButton) closeButton.focus();
    });
  }

  function closeDrawer() {
    if (form) restoreApplied();
    window.clearTimeout(keyboardTimer);
    drawer.classList.remove('is-keyboard');
    drawer.classList.remove('is-open');
    openButton.setAttribute('aria-expanded', 'false');
    if (window.visualViewport) {
      window.visualViewport.removeEventListener('resize', keepPagePinned);
      window.visualViewport.removeEventListener('scroll', keepPagePinned);
    }
    if (window.Belnay && window.Belnay.unlockPageScroll) window.Belnay.unlockPageScroll('collection-filter');
    window.setTimeout(function () {
      if (!drawer.classList.contains('is-open')) drawer.hidden = true;
    }, 400);
    openButton.focus();
  }

  openButton.addEventListener('click', openDrawer);
  if (closeButton) closeButton.addEventListener('click', closeDrawer);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !drawer.hidden) closeDrawer();
  });

  if (!form) return;

  var seeButton = form.querySelector('.collection-drawer__see');
  var clearButton = form.querySelector('[data-filter-clear]');
  var sectionId = root.getAttribute('data-section-id');
  var appliedLabel = seeButton ? seeButton.textContent.replace(/\s+/g, ' ').trim() : '';
  var requestId = 0;
  var countTimer = 0;
  if (seeButton) seeButton.textContent = appliedLabel;

  function ceilingAmount() {
    var maxInput = form.querySelector('[data-price-input="max"]');
    if (!maxInput) return null;
    var cents = parseInt(maxInput.getAttribute('data-price-cents'), 10) || 0;
    return cents > 0 ? cents / 100 : null;
  }

  function normalizedPrices() {
    var minInput = form.querySelector('[data-price-input="min"]');
    var maxInput = form.querySelector('[data-price-input="max"]');
    var min = minInput ? parseMoney(minInput.value) : null;
    var max = maxInput ? parseMoney(maxInput.value) : null;
    var ceiling = ceilingAmount();
    if (min !== null && min <= 0) min = null;
    if (max !== null && ceiling !== null && max >= ceiling - 0.001) max = null;
    if (min !== null && max !== null && min > max) {
      var swap = min;
      min = max;
      max = swap;
    }
    return { min: min, max: max, minInput: minInput, maxInput: maxInput };
  }

  function readState() {
    return {
      checks: Array.prototype.map.call(form.querySelectorAll('input[type="checkbox"]'), function (input) {
        return input.checked;
      }),
      prices: Array.prototype.map.call(form.querySelectorAll('[data-price-input]'), function (input) {
        return input.value;
      }),
      sort: (form.querySelector('select[name="sort_by"]') || { value: '' }).value
    };
  }

  function writeState(state) {
    form.querySelectorAll('input[type="checkbox"]').forEach(function (input, index) {
      input.checked = !!state.checks[index];
    });
    form.querySelectorAll('[data-price-input]').forEach(function (input, index) {
      input.value = state.prices[index] || '';
    });
    var sort = form.querySelector('select[name="sort_by"]');
    if (sort) sort.value = state.sort;
  }

  var appliedState = readState();

  function formIsDirty() {
    var prices = normalizedPrices();
    return !!(form.querySelector('input[type="checkbox"]:checked:not(:disabled)') || prices.min !== null || prices.max !== null);
  }

  function syncClear() {
    if (!clearButton) return;
    clearButton.hidden = !formIsDirty();
  }

  function buildParams() {
    var params = new URLSearchParams();
    form.querySelectorAll('input[type="hidden"]').forEach(function (input) {
      if (input.name) params.append(input.name, input.value);
    });
    form.querySelectorAll('input[type="checkbox"]:checked').forEach(function (input) {
      if (!input.disabled && input.name) params.append(input.name, input.value);
    });
    var prices = normalizedPrices();
    if (prices.min !== null && prices.minInput) params.append(prices.minInput.name, String(prices.min));
    if (prices.max !== null && prices.maxInput) params.append(prices.maxInput.name, String(prices.max));
    var sort = form.querySelector('select[name="sort_by"]');
    if (sort && sort.value) params.set('sort_by', sort.value);
    if (sectionId) params.set('section_id', sectionId);
    return params;
  }

  function updateCount() {
    syncClear();
    if (!seeButton || !sectionId) return;
    var id = ++requestId;
    seeButton.setAttribute('aria-busy', 'true');
    var action = form.getAttribute('action') || window.location.pathname;
    fetch(action + '?' + buildParams().toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (res) {
        if (!res.ok) throw new Error('count');
        return res.text();
      })
      .then(function (html) {
        if (id !== requestId) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var next = doc.querySelector('.collection-drawer__see');
        if (next) seeButton.textContent = next.textContent.replace(/\s+/g, ' ').trim();
      })
      .catch(function () {})
      .then(function () {
        if (id === requestId && seeButton) seeButton.removeAttribute('aria-busy');
      });
  }

  function scheduleCount() {
    syncClear();
    window.clearTimeout(countTimer);
    countTimer = window.setTimeout(updateCount, 280);
  }

  function restoreApplied() {
    requestId += 1;
    window.clearTimeout(countTimer);
    writeState(appliedState);
    if (seeButton) {
      seeButton.textContent = appliedLabel;
      seeButton.removeAttribute('aria-busy');
    }
    syncClear();
  }

  form.addEventListener('change', function (e) {
    if (!e.target || e.target.type !== 'checkbox') return;
    scheduleCount();
  });

  form.querySelectorAll('[data-price-input]').forEach(function (input) {
    input.addEventListener('focus', function () {
      holdKeyboardShield();
      var length = input.value.length;
      window.requestAnimationFrame(function () {
        try { input.setSelectionRange(0, length); } catch (err) {}
      });
    });
    input.addEventListener('blur', releaseKeyboardShield);
    input.addEventListener('input', scheduleCount);
  });

  if (clearButton) {
    clearButton.addEventListener('click', function () {
      form.querySelectorAll('input[type="checkbox"]').forEach(function (input) {
        input.checked = false;
      });
      form.querySelectorAll('[data-price-input]').forEach(function (input) {
        input.value = '';
      });
      if (/(?:^|&)filter\./.test(window.location.search.slice(1))) {
        if (form.requestSubmit) form.requestSubmit();
        else form.submit();
        return;
      }
      updateCount();
    });
  }

  syncClear();

  form.addEventListener('submit', function () {
    var prices = normalizedPrices();
    if (prices.minInput) {
      if (prices.min === null) prices.minInput.disabled = true;
      else prices.minInput.value = String(prices.min);
    }
    if (prices.maxInput) {
      if (prices.max === null) prices.maxInput.disabled = true;
      else prices.maxInput.value = String(prices.max);
    }
  });
})();
